/**
 * Generated by orval. Do not edit manually.
 */
import { useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { AdminMeResponse, ErrorResponse } from '../models'

import getAdminMeMutator from '../../../../admin-client'

/**
 * @summary Get Admin Me
 */
export const getAdminMe = (signal?: AbortSignal) => {
  return getAdminMeMutator<AdminMeResponse>({ url: `/admin/v2/me/`, method: 'GET', signal })
}

export const getGetAdminMeQueryKey = () => {
  return [`/admin/v2/me/`] as const
}

export const getGetAdminMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMe>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAdminMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMe>>> = ({ signal }) =>
    getAdminMe(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMe>>>
export type GetAdminMeQueryError = ErrorResponse

export function useGetAdminMe<
  TData = Awaited<ReturnType<typeof getAdminMe>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMe>>,
          TError,
          Awaited<ReturnType<typeof getAdminMe>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMe<
  TData = Awaited<ReturnType<typeof getAdminMe>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMe>>,
          TError,
          Awaited<ReturnType<typeof getAdminMe>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMe<
  TData = Awaited<ReturnType<typeof getAdminMe>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Me
 */

export function useGetAdminMe<
  TData = Awaited<ReturnType<typeof getAdminMe>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMe>>, TError, TData>>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAdminMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
